export const tutorialViewedExpireTime = 365 * 2
